// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/command.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Agent } from "../../common/v1/common_pb";
import { RawStorageTrait_SetRecording, RawStorageTrait_SetStorageUrl } from "../../trait/sensor/v1/raw_storage_pb";
import { OtaTrait_Command } from "../../trait/update/v1/ota_pb";
import { AppTrait_Command } from "../../trait/update/v1/app_pb";
import { SpeechTrait_TextToSpeechCommand } from "../../trait/speech/v1/speech_pb";
import { RemotePropertiesTrait_SendRemoteProperties } from "../../trait/remoteproperties/v1/remote_properties_pb";
import { InitiateCallTrait_InitiateCallCommand } from "../../trait/hub/v1/call_pb";

/**
 * @generated from message msh.service.v1.Command
 */
export const Command = proto3.makeMessageType(
  "msh.service.v1.Command",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent", kind: "message", T: Agent },
    { no: 3, name: "creation_time", kind: "message", T: Timestamp },
    { no: 4, name: "raw_storage_command", kind: "message", T: RawStorageTrait_SetRecording, oneof: "command" },
    { no: 5, name: "storage_url_command", kind: "message", T: RawStorageTrait_SetStorageUrl, oneof: "command" },
    { no: 6, name: "ota_command", kind: "message", T: OtaTrait_Command, oneof: "command" },
    { no: 7, name: "app_command", kind: "message", T: AppTrait_Command, oneof: "command" },
    { no: 8, name: "device_command", kind: "enum", T: proto3.getEnumType(Command_DeviceCommand), oneof: "command" },
    { no: 9, name: "text_to_speech", kind: "message", T: SpeechTrait_TextToSpeechCommand, oneof: "command" },
    { no: 10, name: "remote_property", kind: "message", T: RemotePropertiesTrait_SendRemoteProperties, oneof: "command" },
    { no: 11, name: "initiate_call_command", kind: "message", T: InitiateCallTrait_InitiateCallCommand, oneof: "command" },
  ],
);

/**
 * @generated from enum msh.service.v1.Command.DeviceCommand
 */
export const Command_DeviceCommand = proto3.makeEnum(
  "msh.service.v1.Command.DeviceCommand",
  [
    {no: 0, name: "DEVICE_COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DEVICE_COMMAND_REBOOT", localName: "REBOOT"},
    {no: 2, name: "DEVICE_COMMAND_REFRESH_AUTHENTICATION", localName: "REFRESH_AUTHENTICATION"},
  ],
);

